var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "member-profile tongxin-layout"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("家庭成員資料")]), _vm.memberData ? _c('div', {
    staticClass: "profile-card"
  }, [_c('div', {
    staticClass: "profile-body"
  }, [_c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("姓名")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.memberData.ptName))])]), _c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("身分證字號")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.memberData.ptIdno))])]), _c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("出生年月日")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formattedBirthday))])])]), _c('div', {
    staticClass: "profile-footer"
  }, [_vm.isAuthorized ? _c('div', {
    staticClass: "reminder-green"
  }, [_vm._v(" 授權 " + _vm._s(_vm.memberData.ptName) + " 先生（或 xxx 女士）已授權您新增本項修改紀錄，並代替本人處理相關事務。 ")]) : _c('div', {
    staticClass: "reminder-yellow"
  }, [_vm._v(" 此成員尚未授權，待對方同意後即可代為預約。 ")])])]) : _vm._e(), _c('div', {
    staticStyle: {
      "padding-bottom": "96px"
    }
  }), _c('div', {
    staticClass: "fixed-footer-navigation"
  }, [_c('button', {
    staticClass: "btn btn-secondary w-50",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" 返回 ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }